import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../controls/Button";
import { useNavigate } from "react-router-dom";

interface LinkPaymentModalProps {
  show: boolean;
  onHide: () => void;
}

const LinkPaymentModal: React.FC<LinkPaymentModalProps> = ({
  show,
  onHide,
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="text-center">
          <img src="/assets/imgs/link-payment-icon.svg" alt="" />
        </div>
        <h1 className="mt-3">Link payment gateway</h1>
        <p>
          Please create your Trustap account to start selling your artworks.
          This account is required to receive payouts from your sales.
        </p>
        <div className="d-flex gap-2 justify-content-end">
          <div className="formMain mt-0">
            <Button
              title="Get Started"
              onClick={() => navigate("/dashboard/trustap-account")}
              style={{ width: 150 }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LinkPaymentModal;
